import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import FontAwesome from 'react-fontawesome'
import config from '../config'
import Select from 'react-select';
import { actions, selectors } from '../sagas/stripe_settings'
import { TextInput } from '../shared/TextInput'
import { reduxForm } from 'redux-form'
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { StripeProvider } from 'react-stripe-elements';
import FontAwesomeIcon from 'react-fontawesome'
import Square from '@fortawesome/fontawesome-free-solid/faSquare'
import '../stylesheets/Settings.sass'
import '../stylesheets/selector.sass'


class BankAccountSettingsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      stripe: null,
      bankAccountInfo: false
    };
  }

  componentWillMount () {
    const script = document.createElement("script");

    script.src = "https://js.stripe.com/v3/"
    script.async = 'true'
    script.id = 'stripe-js'

    document.head.appendChild(script);
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({stripe: window.Stripe(config.STRIPE_API_KEY)});
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({stripe: window.Stripe(config.STRIPE_API_KEY)});
      });
    }
  }

  handleCustomSubmit = () => {
    this.props.createStripeInfo()
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <StripeProvider stripe={this.state.stripe}>
        <form
          onSubmit={handleSubmit(this.handleCustomSubmit)}>
          <div>
            <div>
              <TextInput
                placeholderText={'Routing Number'}
                inputName={'routingNumber'}
                label={'Routing Number'}
                required={ this.props.create }
              />
              <TextInput
                placeholderText={'Account Number'}
                inputName={'accountNumber'}
                label={'Account Number'}
                required={ this.props.create }
              />
              <TextInput
                placeholderText={'Confirm Account Number'}
                inputName={'accountNumberConfirmation'}
                label={'Account Number Confirmation'}
                required={ this.props.create}
              />
            </div>
          </div>
          <button className='alt-button setting-form' type="submit">
            Save Bank Account Information
          </button>
        </form>
      </StripeProvider>
    )
  }
}

const mapStateToProps = (store) => ({
  loaded: selectors.loaded(store),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  { form: 'bank_account_form'}
)(BankAccountSettingsForm)));



// WEBPACK FOOTER //
// ./src/Settings/bank_account_form.jsx